import { Component, OnInit, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/user/authentication.service';
import { GlobalHelper } from '../services/Common/global.service';
import { PublicService } from '../services/public/public.service';
import { CommonService } from '../services/Common/common.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css']
})

export class PublicComponent implements OnInit {
  @ViewChild('myDiv',{static:false}) myDiv: ElementRef<HTMLElement>;
  constructor(@Inject(DOCUMENT) private document: Document,
  
  private renderer: Renderer2, private router:Router,public elementRef: ElementRef,
  private  publicService:PublicService,public globalHelper :GlobalHelper, 
  private commonService:CommonService,private titleService:Title) { 
    this.maphide ='navbar-collapse collapse';  
    window.localStorage.clear();
    this.globalHelper.SiteMap=null;
  }
  maphide:any;
  WebsiteModel:any;
  GetSchoolWebsite  () {
   
    this.publicService.GetSchoolWebsite().subscribe( (data) =>{
        this.WebsiteModel = data.WebsiteData[0];   
        this.globalHelper.CheckActionStatus(data);
        if(this.WebsiteModel!=null){
          this.titleService.setTitle(this.WebsiteModel.DirectorName);
        }
        
    });
};
ChanggeMenu(){
  let el: HTMLElement = this.myDiv.nativeElement;
    el.click();
}
SiteMapList=[];
  ngOnInit() {
  
  this.globalHelper.App="PUBLIC";
  this.publicService.GetSchoolSiteMap().subscribe((data:any)=>{
    this.SiteMapList = data.SiteMapList;
  })

    this.renderer.removeClass(this.document.body, 'body1');
    this.renderer.removeClass(this.document.body, 'body2');
    
    //this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor ='pink';
   this.GetSchoolWebsite();
  }

}
